<script>
import {mapActions, mapGetters} from "vuex";
import AppLoading from "@/components/elements/AppLoading.vue";
import {VesselService} from "@/services/VesselService";
import { toBlob } from 'dom-to-image-more';
import {permissionMixin} from "@/mixins/permissionMixins";

export default {
  name: "SummaryPerCrewAgeContainer",
  mixins : [permissionMixin],
  components: {AppLoading},
  data() {
    const rankLabels = this.data[0].crews.map(crew => crew.rank_name.toUpperCase());
    const rankData = this.data[0].crews.map(crew => {
      return {
        rank_id : crew.rank_id,
        rank_name : crew.rank_name,
      }
    });
    const series = [
      {
        name: "<25",
        data: this.getTotalCrewBasedOnAgeRange(rankLabels, null, 24),
        value_from : null,
        value_to : 24,
        color : '#e69f00'
      },
      {
        name: "25–29",
        data: this.getTotalCrewBasedOnAgeRange(rankLabels, 25, 29),
        value_from : 25,
        value_to : 29,
        color : '#56b4e9'
      },
      {
        name: "30–34",
        data: this.getTotalCrewBasedOnAgeRange(rankLabels, 30, 34),
        value_from : 30,
        value_to : 34,
        color : '#31b08d'
      },
      {
        name: "35–39",
        data: this.getTotalCrewBasedOnAgeRange(rankLabels, 35, 39),
        value_from : 35,
        value_to : 39,
        color : '#f0e442'
      },
      {
        name: "40–44",
        data: this.getTotalCrewBasedOnAgeRange(rankLabels, 40, 44),
        value_from : 40,
        value_to : 44,
        color : '#0172b2'
      },
      {
        name: "45–49",
        data: this.getTotalCrewBasedOnAgeRange(rankLabels, 45, 49),
        value_from : 45,
        value_to : 49,
        color : '#d55e00'
      },
      {
        name: "50+",
        data: this.getTotalCrewBasedOnAgeRange(rankLabels, 50, null),
        value_from : 50,
        value_to : null,
        color : '#cc79a7'
      },
    ]

    return {
      requestLoading : false,
      rankLabels : rankLabels,
      rankData : rankData,
      series: series,
      chartOptions: {
        chart: {
          type: "bar",
          stacked: true,
          toolbar: { show: false },
          events : {
            xAxisLabelClick: async function(event, chartContext, config){
              this.modalFilter.individual = false;
              this.modalFilter.series_index = null;

              this.selectedDataForModal.title = rankLabels[config.labelIndex];
              $('#summary_per_crew_age_modal').modal('show');
              const rank_id = this.rankData[config.labelIndex].rank_id;
              this.modalFilter.rank_id = rank_id;
              await this.requestNewData({
                rank_id : rank_id
              })
            }.bind(this),
            dataPointSelection: async (event, chartContext, config) => {
              this.modalFilter.individual = true;
              this.modalFilter.series_index = null;
              this.selectedDataForModal.title = rankLabels[config.dataPointIndex];
              $('#summary_per_crew_age_modal').modal('show');
              const rank_id = this.rankData[config.dataPointIndex].rank_id;
              this.modalFilter.rank_id = rank_id;
              const legendIndex = Object.keys(config.selectedDataPoints)[0];
              await this.requestNewData({
                age_from : series[legendIndex].value_from,
                age_to : series[legendIndex].value_to,
                rank_id : rank_id
              })
            }
          }
        },
        title: {
          text: 'Crew Count by Rank and Age Group'.toUpperCase(),
          align: "center",
        },
        xaxis: {
          categories: rankLabels,
          title: { text: 'NUMBER OF CREW' },
        },
        yaxis: {
          title: { text: 'RANK' },
        },
        legend: {
          position: "right",
          offsetY: 50,
          markers: {
            width: 30,
            offsetX: -5,
            offsetY : 2
          },
          style: {
            fontWeight: 600,
            fontSize: "13px",
          },
        },
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: "80%",
          },
        },
        dataLabels: {
          enabled: true,
          style: { colors: ['#000'] },
        },
        colors: series.map(item => item.color),
        grid: {
          borderColor: "#e0e0e0",
          strokeDashArray: 3,
        },
      },
      selectedDataForModal : {
        full_data_index : 0,
        data : [],
      },
      modalFilter : {
        series_index : null,
        individual : true,
        rank_id : null
      }
    }
  },
  props : {
    data : {
      type : Array,
      default : []
    }
  },
  methods: {
    ...mapActions([
      'getBasedOnAgeAndRankList'
    ]),
    setLegendCss() {
      setTimeout(() => {
        const apexLegendContainer = $('#summary_per_crew_age .apexcharts-legend');
        const ageGroup = apexLegendContainer.children('span');
        if (ageGroup.length === 0) {
          apexLegendContainer.prepend('<span>Age Group</span>')
        }
        apexLegendContainer.css({
          height: 'fit-content',
          padding: '10px',
          border: '1px solid rgb(0 0 0 / 13%)'
        })
      }, 500);
    },
    getTotalCrewBasedOnAgeRange(rankLabels, ageFrom = null, ageTo = null) {
      const data = [];
      const filteredCrews = this.data.filter(item => {
        if (ageFrom !== null && ageTo !== null)
          return item.age >= ageFrom && item.age <= ageTo;
        else if (ageTo !== null)
          return item.age <= ageTo;
        else if (ageFrom !== null)
          return item.age >= ageFrom;
      });

      rankLabels.forEach(rank => {
        let rankTotal = 0;
        filteredCrews.forEach(item => {
          const crewBasedOnRank = item.crews.filter(crew => {
            return crew.rank_name.toLowerCase() === rank.toLowerCase()
          })

          rankTotal += crewBasedOnRank[0]?.total || 0;

        })
        data.push(rankTotal);
      })
      return data;
    },
    getLegendColor(age) {
      return this.series.filter(item =>
        (item.value_from === null || age >= item.value_from) &&
        (item.value_to === null || age <= item.value_to)
      )[0]?.color || ''
    },
    async requestNewData(params) {
      this.requestLoading = true;
      await this.getBasedOnAgeAndRankList(params)
      this.selectedDataForModal.data = this.basedOnAgeAndRankList.sort((a, b) => a.age - b.age);
      this.requestLoading = false;
    },
    async getGraphImage() {
      swal.fire({
        'title': `Exporting Summary Per Crew Age Graph`,
        'text': "Please wait...",
        'imageUrl': "https://img.icons8.com/external-tal-revivo-tritone-tal-revivo/64/external-horizontal-bar-graph-chart-isolated-on-a-white-background-business-tritone-tal-revivo.png",
        'imageWidth': 100,
        'imageHeight': 100,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false
      })
      swal.showLoading()

      const blob = await toBlob(this.$refs["summary_per_crew_age"], {
        pixelRatio: 2,
        backgroundColor: 'white'
      });

      const formData = new FormData();
      formData.append("chart_image", blob, "chart.png");
      formData.append("report_type", 'Summary Per Crew Age');

      const printResponse = await VesselService.printSummaryOfManagingVesselGraph(formData);
      swal.close()
      let url = window.URL.createObjectURL(new Blob([printResponse.data],{type:'application/pdf'}))
      let filename=`summary_per_crew_age_${Date.now()}.pdf`;
      const link = document.createElement('a');
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
    },
  },
  computed: {
    ...mapGetters([
      'basedOnAgeAndRankList'
    ]),
  },
  mounted() {
    this.setLegendCss();
    window.addEventListener("resize", this.setLegendCss);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.setLegendCss);
  },
}
</script>

<template>
  <div class="col-12">
    <div class="card shadow-sm">
      <div class="card-body mb-5">
        <div class="row mt-2">
          <div class="col-12" v-if="['k-line-persons', 'k-line-persons2'].includes(user.roles_permissions?.roles[0]) === false">
            <button class="cursor-pointer float-right ml-2 e-btn e-btn-blue-gray force-white-all"
                    @click="getGraphImage"
            >
              <font-awesome-icon class="mr-1" icon="download"/>
              Download Graph
            </button>
          </div>
          <div class="col-12" id= "summary_per_crew_age" ref = "summary_per_crew_age">
            <div>
              <apexchart
                ref="pie-chart-container"
                type="bar"
                height="auto"
                :options="chartOptions"
                :series="series">
              </apexchart>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="modal fade" id="summary_per_crew_age_modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ selectedDataForModal.title }}</h5>
            <select v-if="modalFilter.individual === false" class="ml-2 form-control form-control-sm text-uppercase w-auto" v-model="modalFilter.series_index" @change="requestNewData(
              {
                age_from : series[modalFilter.series_index]?.value_from ?? null,
                age_to : series[modalFilter.series_index]?.value_to ?? null,
                rank_id : modalFilter.rank_id
            })">
              <option :value="null"> --- ALL --- </option>
              <option :value="index" v-for="(item, index) in series" :style="{backgroundColor: item.color, color: 'black' }">{{ item.name }}</option>
            </select>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="max-height: 60vh; overflow-y: auto">
            <div class="col-12">
              <div>
                <table class="table table-bordered mr-1">
                  <thead>
                  <tr>
                    <th class="text-center text-uppercase align-middle" style="background-color: #c9c9c9;">
                      #
                    </th>
                    <th class="text-center text-uppercase align-middle" style="background-color: #c9c9c9;">
                      NAME
                    </th>
                    <th class="text-center text-uppercase align-middle" style="background-color: #c9c9c9;">
                      AGE
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <template v-if="requestLoading === true">
                    <tr>
                      <td colspan="100%">
                        <app-loading/>
                      </td>
                    </tr>
                  </template>
                  <template v-else>
                    <template v-if="selectedDataForModal.data.length === 0">
                      <td colspan="100%" class="align-middle text-center">
                        <p class="h5 py-1">NO RESULTS FOUND</p>
                      </td>
                    </template>
                    <tr v-for="(data, index) in selectedDataForModal.data">
                      <td class="text-center align-middle">
                        {{ index + 1 }}
                      </td>
                      <td class="text-center align-middle">
                        {{ data.full_name }}
                      </td>
                      <td class="text-center align-middle">
                        <div class="p-1" :style="{backgroundColor: getLegendColor(data.age), color: 'black'}">
                          {{ data.age }}
                        </div>
                      </td>
                    </tr>
                  </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
